import { render, staticRenderFns } from "./period.vue?vue&type=template&id=06e79411&scoped=true&"
import script from "./period.vue?vue&type=script&lang=js&"
export * from "./period.vue?vue&type=script&lang=js&"
import style0 from "./period.vue?vue&type=style&index=0&id=06e79411&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e79411",
  null
  
)

export default component.exports